import type Luminary from '@lumen5/luminary';

import { SubagentAccess } from './subagentAccess';
import { SubagentScope } from './SubagentScope';
import { resolveSceneById } from '../tools/scene-addressing';

import type { GetRootState } from 'js/src/libs/RootState';

/**
 * Pins a child conversation's edits to the one scene it was started for. The child's tools are
 * chosen for it, so nothing else is refused: it may read and review freely, but every edit must
 * name its own scene.
 */
export class SingleSceneScope extends SubagentScope {
    constructor(
        private readonly sceneLuminary: Luminary,
        private readonly sceneGetState: GetRootState,
        private readonly sceneId: string,
    ) {
        const sceneGroupId = sceneLuminary.getSceneById(sceneId)?.sceneGroup?.id;
        super(sceneLuminary, sceneGetState, sceneGroupId ? [sceneGroupId] : []);
    }

    public override checkToolCall(
        access: SubagentAccess,
        toolName: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        args: Record<string, any>,
    ): string | null {
        if (access !== SubagentAccess.EDITS_TARGET && access !== SubagentAccess.PLACEMENT) {
            return null;
        }
        const resolved =
            typeof args.scene_id === 'string'
                ? resolveSceneById(this.sceneLuminary, this.sceneGetState(), args.scene_id)
                : null;
        if (resolved && !('error' in resolved) && resolved.scene.id === this.sceneId) {
            return null;
        }
        return `${toolName} must name scene_id ${this.sceneId}, the scene you were started for.`;
    }
}
